import apiClient from './api';
import { validateRequiredParams } from '@/utils/apiUtils';
import { TopContentParams, TopContentResponse } from '@/types/topContent.types';

export const getTopContent = async (params: TopContentParams): Promise<TopContentResponse> => {
  validateRequiredParams(params, ['tenant_code']);

  const { tenant_code, ...queryParams } = params;

  const response = await apiClient.get<TopContentResponse>(
    `/top-content/${encodeURIComponent(tenant_code)}`,
    { params: queryParams }
  );

  return response.data;
};
